
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["ICON_PDF",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"class":"ICON_PDF","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 73.95 87"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"data-name":"Path 3141","d":"M67.425 17.399H56.55V6.525a6.533 6.533 0 00-6.525-6.526H17.398a2.176 2.176 0 00-1.54.64L.633 15.864a2.154 2.154 0 00-.635 1.535v45.675a6.533 6.533 0 006.525 6.525h10.875v10.875a6.533 6.533 0 006.527 6.525h43.5a6.533 6.533 0 006.525-6.525v-56.55a6.533 6.533 0 00-6.525-6.525zM17.398 5.251v9.974a2.176 2.176 0 01-2.175 2.175H5.248zm-10.875 60a2.176 2.176 0 01-2.175-2.175V21.75h10.875a6.533 6.533 0 006.525-6.525V4.35h28.275a2.176 2.176 0 012.175 2.175v10.874h-17.4a2.177 2.177 0 00-1.54.639L18.033 33.263a2.154 2.154 0 00-.635 1.535v30.45zm28.275-42.6v9.974a2.176 2.176 0 01-2.175 2.175h-9.975zm34.8 57.824a2.176 2.176 0 01-2.175 2.175h-43.5a2.176 2.176 0 01-2.175-2.175V39.15h10.875a6.533 6.533 0 006.525-6.525V21.75h28.275a2.176 2.176 0 012.175 2.175z"}})])
          )
        }
      }
    